import { render, staticRenderFns } from "./homeapproval.vue?vue&type=template&id=2a104026"
import script from "./homeapproval.vue?vue&type=script&lang=js"
export * from "./homeapproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports